import type { FC } from "react";

import type { FeatureHook } from "./createFeatureHook";

const APPLICATION_JSON = "application/json;charset=UTF-8";

type FeatureVariations<TProps, TReturn> =
  | Array<FC<TProps> | null>
  | Array<FeatureHook<TProps, TReturn> | null>;

export const fetchEvaluateFeature = ({
  context,
  name,
  index,
  evaluable,
}: {
  context: string;
  name: string;
  index: number | undefined;
  evaluable: boolean;
}) => {
  fetch(`${context}/features-event-tracks/evaluate-feature`, {
    method: "POST",
    headers: {
      "Content-Type": APPLICATION_JSON,
    },
    body: JSON.stringify({
      name,
      index: index,
      evaluable: !!evaluable,
    }),
  });
};

export function parsePartition<TProps, TReturn>({
  variations,
  index,
  version,
}: {
  variations: FeatureVariations<TProps, TReturn>;
  index: number | undefined;
  version: number;
}): number {
  if (version === 1) {
    return !index || variations.length < index ? 0 : index - 1;
  }
  return !index || variations.length < index + 1 ? 0 : index;
}
